import { ModalHeader as Header } from './Header';
import { ModalBody as Body } from './Body';
import { ModalFooter as Footer } from './Footer';

export { Header as ModalHeader };
export { Body as ModalBody };
export { Footer as ModalFooter };
